import { Body, Stack, Title } from '@optimus-web/core';
import { OrderItem } from '@mews-commander/data-access';
import { UnicodeEntity } from '@mews/enums';
import { LocalizedCurrencyValue, LocalizedText, sumNumbersAsDecimals } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';

export const ItemTotalCost = ({ orderItem }: { orderItem: OrderItem }) => {
    const { totalAmount } = orderItem;

    const totalTaxValue = totalAmount.taxValues?.reduce((acc, { value }) => sumNumbersAsDecimals(value, acc), 0);

    if (!orderItem) {
        return null;
    }

    return (
        <Stack vertical itemAlignment="end">
            <Body size="small" variant="secondary">
                <LocalizedText textKey={TextKey.Tax} />
                {UnicodeEntity.Colon}
                {UnicodeEntity.NoBreakSpace}
                <LocalizedCurrencyValue value={{ value: totalTaxValue, currency: totalAmount.currency }} />
            </Body>
            <Title level={2}>
                <LocalizedText textKey={TextKey.TotalInclTax} />
                {UnicodeEntity.Colon}
                {UnicodeEntity.NoBreakSpace}
                <LocalizedCurrencyValue value={totalAmount} />
            </Title>
        </Stack>
    );
};
